
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invasion/mission",
      function () {
        return require("private-next-pages/invasion/mission.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invasion/mission"])
      });
    }
  